<vwui-modal-header>
    <h3>Document {{action}}</h3>
</vwui-modal-header>

<vwui-modal-body [formGroup]="form">
    <vwui-form-group label="Naam">
        <vwui-input formControlName="name" placeholder="Voer een naam in"></vwui-input>
    </vwui-form-group>
    <vwui-form-group label="Link">
        <vwui-input formControlName="link" placeholder="Voer een link in"></vwui-input>
    </vwui-form-group>
    <vwui-form-group label="Soort">
        <app-link-type-select
            formControlName="type"
            placeholder="Kies een soort"
        ></app-link-type-select>
    </vwui-form-group>
</vwui-modal-body>

<vwui-modal-footer>
    <vwui-button class="is-light" (click)="modalRef.close()">Annuleren</vwui-button>
    <vwui-button class="is-primary" (click)="saveLink()" [disabled]="form.invalid || saving">Opslaan</vwui-button>
</vwui-modal-footer>
